import StoreSubscriber from "@/lib/store-subscriber.ts";
import type { Nullable } from "@/types";
import type { DefaultTrackingData } from "../types";
import { pushTrackingData } from "../utils/push-event.ts";

class EventQueue extends StoreSubscriber {
    readonly #queue: DefaultTrackingData[];

    static #instance: Nullable<EventQueue> = null;

    private constructor() {
        super();

        this.#queue = [];
    }

    static getInstance(): EventQueue {
        EventQueue.#instance ??= new EventQueue();
        return EventQueue.#instance;
    }

    get queue() {
        return this.#queue;
    }

    push(data: DefaultTrackingData) {
        this.updateStore(() => {
            this.#queue.push(data);
        });
    }

    flush() {
        this.updateStore(() => {
            while (this.#queue.length > 0) {
                const data = this.#queue.shift();
                if (!data) return;

                pushTrackingData(data);
            }
        });
    }
}

export default EventQueue;
